export function getIdFromUrlHash() {
    const hashParts = window.location.hash.split('#');
    return hashParts.length >= 2 ? hashParts[1].split('-')[1] : null;
}



// WEBPACK FOOTER //
// ./~/@99designs/ddo/lib/urlHash.js